import { render, staticRenderFns } from "./ConnectJT.vue?vue&type=template&id=061480ec&"
import script from "./ConnectJT.vue?vue&type=script&lang=js&"
export * from "./ConnectJT.vue?vue&type=script&lang=js&"
import style0 from "./ConnectJT.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VExpandTransition,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061480ec')) {
      api.createRecord('061480ec', component.options)
    } else {
      api.reload('061480ec', component.options)
    }
    module.hot.accept("./ConnectJT.vue?vue&type=template&id=061480ec&", function () {
      api.rerender('061480ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Shipping/components/ShippingManage/ConnectJT.vue"
export default component.exports